import script from "./contedo-dashboard2.vue?vue&type=script&setup=true&lang=js"
export * from "./contedo-dashboard2.vue?vue&type=script&setup=true&lang=js"

import "./contedo-dashboard2.vue?vue&type=style&index=0&id=2c2504f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c2504f3"]])

export default __exports__